const FIGURE_TYPES = ["hourglass", "pear", "apple", "rectangle", "inverted-triangle"];

const QUESTIONS = [
    {
        id: "shoulders-hips",
        title: "Jak porównałabyś szerokość ramion i bioder?",
        hint: "Stań prosto przed lustrem albo porównaj pomiary w najszerszych miejscach.",
        answers: [
            { id: "balanced", label: "Ramiona i biodra są podobnej szerokości", scores: { hourglass: 3, rectangle: 3, apple: 1 } },
            { id: "hips-wider", label: "Biodra są wyraźnie szersze od ramion", scores: { pear: 6 } },
            { id: "shoulders-wider", label: "Ramiona są wyraźnie szersze od bioder", scores: { "inverted-triangle": 6 } },
        ],
    },
    {
        id: "waist",
        title: "Jak wyraźnie zaznaczona jest Twoja talia?",
        hint: "Oceń naturalne wcięcie między żebrami a biodrami, bez wciągania brzucha.",
        answers: [
            { id: "defined", label: "Bardzo wyraźnie — talia jest zauważalnie węższa", scores: { hourglass: 6, pear: 1 } },
            { id: "soft-waist", label: "Lekko — wcięcie jest widoczne, ale delikatne", scores: { pear: 3, "inverted-triangle": 2, hourglass: 1 } },
            { id: "straight-waist", label: "Słabo — talia, biust i biodra tworzą prostszą linię", scores: { rectangle: 6, apple: 1 } },
            { id: "fuller-waist", label: "Najpełniejszy jest środek sylwetki", scores: { apple: 6 } },
        ],
    },
    {
        id: "fullness",
        title: "W której części sylwetki najczęściej skupia się objętość?",
        hint: "Pomyśl o tym, gdzie ubrania zwykle stają się najciaśniejsze jako pierwsze.",
        answers: [
            { id: "balanced-curves", label: "Równomiernie w biuście i biodrach, z wyraźną talią", scores: { hourglass: 5 } },
            { id: "lower-body", label: "Głównie w biodrach, pośladkach i udach", scores: { pear: 5 } },
            { id: "midsection", label: "Głównie w okolicy brzucha i talii", scores: { apple: 5 } },
            { id: "evenly", label: "Dość równomiernie, bez jednej dominującej partii", scores: { rectangle: 5 } },
            { id: "upper-body", label: "Głównie w biuście, ramionach lub barkach", scores: { "inverted-triangle": 5 } },
        ],
    },
    {
        id: "fitted-clothes",
        title: "Jak zwykle układa się na Tobie dopasowana sukienka?",
        hint: "Wybierz opis proporcji, nie rozmiaru ani tego, czy lubisz dopasowane ubrania.",
        answers: [
            { id: "balanced-fit", label: "Podkreśla podobny biust i biodra oraz wyraźną talię", scores: { hourglass: 6 } },
            { id: "bottom-fit", label: "Jest luźniejsza u góry, a ciaśniejsza na biodrach", scores: { pear: 6 } },
            { id: "middle-fit", label: "Najbardziej przylega w okolicy brzucha", scores: { apple: 6 } },
            { id: "straight-fit", label: "Układa się dość prosto od ramion do bioder", scores: { rectangle: 6 } },
            { id: "top-fit", label: "Jest ciaśniejsza u góry, a luźniejsza na biodrach", scores: { "inverted-triangle": 6 } },
        ],
    },
    {
        id: "best-cut",
        title: "Który efekt w ubraniach zwykle najlepiej równoważy Twoją sylwetkę?",
        hint: "Wybierz to, w czym czujesz, że proporcje wyglądają najbardziej harmonijnie.",
        answers: [
            { id: "wrap", label: "Podkreślona talia i dopasowana góra oraz dół", scores: { hourglass: 5 } },
            { id: "a-line", label: "Wyraźniejsza góra i spokojny, lekko rozszerzany dół", scores: { pear: 5 } },
            { id: "empire", label: "Pionowe linie i fason swobodniejszy w okolicy talii", scores: { apple: 5 } },
            { id: "shape-building", label: "Pasek, warstwy lub fason tworzący optyczne wcięcie", scores: { rectangle: 5 } },
            { id: "volume-lower", label: "Prosta góra oraz spodnie lub spódnica dodające objętości dołowi", scores: { "inverted-triangle": 5 } },
        ],
    },
    {
        id: "measurements",
        title: "Który opis najlepiej pasuje do Twoich pomiarów?",
        hint: "Jeśli nie masz miarki, wybierz odpowiedź na podstawie obserwacji w lustrze.",
        answers: [
            { id: "balanced-measurements", label: "Biust i biodra są zbliżone, a talia wyraźnie mniejsza", scores: { hourglass: 7 } },
            { id: "hips-largest", label: "Biodra są największym pomiarem", scores: { pear: 7 } },
            { id: "midsection-largest", label: "Talia lub brzuch są zbliżone do biustu i bioder albo większe", scores: { apple: 7 } },
            { id: "measurements-close", label: "Biust, talia i biodra są dość zbliżone", scores: { rectangle: 7 } },
            { id: "shoulders-largest", label: "Ramiona lub biust są wyraźnie szersze od bioder", scores: { "inverted-triangle": 7 } },
        ],
    },
];

const RESULT_DATA = {
    hourglass: {
        name: "Klepsydra",
        tone: "Zrównoważone proporcje i wyraźna talia",
        summary: "Masz jedną z najbardziej proporcjonalnych sylwetek – ramiona i biodra są zbliżonej szerokości, a talia jest pięknie zaznaczona. To figura, która świetnie wygląda zarówno w klasycznych, jak i najnowszych trendach. Kluczem jest podkreślenie naturalnych proporcji, zamiast ich ukrywania.",
        bestFits: ["Sukienki kopertowe i dopasowane fasony.", "Spodnie oraz spódnice z wysokim stanem.", "Paski podkreślające talię.", "Gorsety, taliowane marynarki i body.", "Dekolty w literę V, serce i hiszpańskie."],
        watchOut: "Bardzo pudełkowe i mocno oversize’owe kroje mogą ukrywać naturalne proporcje.",
    },
    pear: {
        name: "Gruszka",
        tone: "Delikatniejsza góra i wyraźniejsze biodra",
        summary: "Masz delikatniejszą górę ciała oraz bardziej kobiece biodra i uda. To bardzo harmonijna sylwetka, którą łatwo zrównoważyć odpowiednimi proporcjami. Wystarczy delikatnie przyciągnąć uwagę do ramion i talii, a całość będzie wyglądać niezwykle elegancko.",
        bestFits: ["Bluzki z ciekawymi rękawami lub dekoltem.", "Jasne kolory na górze, ciemniejsze na dole.", "Rozkloszowane sukienki i spódnice A.", "Spodnie z prostą lub lekko rozszerzaną nogawką.", "Marynarki z delikatnie zaznaczonymi ramionami."],
        watchOut: "Mocne kieszenie i bardzo duże wzory dokładnie na biodrach mogą zaburzać równowagę sylwetki.",
    },
    apple: {
        name: "Jabłko",
        tone: "Pełniejszy środek sylwetki i smuklejsze nogi",
        summary: "Największym atutem tej sylwetki są zgrabne nogi i często piękny biust. Warto optycznie wydłużyć sylwetkę oraz subtelnie zaznaczyć talię. Dzięki prostym fasonom stylizacje wyglądają lekko, nowocześnie i bardzo elegancko.",
        bestFits: ["Dekolty V i kopertowe kroje.", "Dłuższe marynarki noszone rozpięte.", "Proste, lejące materiały.", "Spodnie z wysokim stanem.", "Monochromatyczne stylizacje wydłużające sylwetkę."],
        watchOut: "Cienkie, mocno opinające materiały w talii mogą tworzyć mniej harmonijne linie.",
    },
    rectangle: {
        name: "Prostokąt",
        tone: "Podobna szerokość ramion, talii i bioder",
        summary: "Ramiona, talia i biodra mają podobną szerokość, dlatego warto stworzyć efekt bardziej zarysowanej talii. Ta sylwetka świetnie prezentuje minimalistyczne i nowoczesne stylizacje. Kilka prostych trików sprawi, że proporcje staną się bardziej kobiece.",
        bestFits: ["Paski i taliowane marynarki.", "Sukienki kopertowe oraz z wiązaniem.", "Warstwowe stylizacje.", "Spodnie z wysokim stanem.", "Falbany lub marszczenia w okolicy bioder i biustu."],
        watchOut: "Jednocześnie bardzo prosta góra i dół mogą dodatkowo spłaszczać proporcje.",
    },
    "inverted-triangle": {
        name: "Odwrócony trójkąt",
        tone: "Wyraźniejsza góra i smuklejsze biodra",
        summary: "Masz wyraźniejsze ramiona oraz smuklejsze biodra, dzięki czemu sylwetka wygląda bardzo sportowo. Stylizacje powinny delikatnie wyrównać proporcje i dodać objętości dolnej części ciała. Efekt? Elegancka, harmonijna i niezwykle modna sylwetka.",
        bestFits: ["Rozszerzane spodnie i spódnice.", "Jasne lub wzorzyste doły.", "Dekolty V oraz kopertowe.", "Proste, minimalistyczne góry.", "Delikatne rękawy bez dużych bufek i falban."],
        watchOut: "Duże bufki, pagony i mocne zdobienia na ramionach mogą niepotrzebnie poszerzać górę.",
    },
};

function calculateFigureType(answerIds) {
    const scores = FIGURE_TYPES.reduce((result, type) => ({ ...result, [type]: 0 }), {});
    QUESTIONS.forEach((question, index) => {
        const answer = question.answers.find((item) => item.id === answerIds[index]);
        if (!answer) return;
        Object.entries(answer.scores).forEach(([type, points]) => { scores[type] += points; });
    });
    const ranking = FIGURE_TYPES.slice().sort((a, b) => scores[b] - scores[a] || FIGURE_TYPES.indexOf(a) - FIGURE_TYPES.indexOf(b));
    const type = ranking[0];
    const runnerUp = ranking[1];
    const answered = answerIds.filter((answerId, index) => QUESTIONS[index]?.answers.some((answer) => answer.id === answerId)).length;
    const gap = scores[type] - scores[runnerUp];
    const consistency = Math.min(96, Math.max(50, 50 + gap * 3 + answered * 2));
    return { type, runnerUp, scores, answered, consistency, ...RESULT_DATA[type] };
}

module.exports = { FIGURE_TYPES, QUESTIONS, RESULT_DATA, calculateFigureType };
